import React, { useState, useContext, useEffect, useRef } from 'react';
import './Pairs.css';

import DropZone from './DropZone';

import Parameter from './Parameter';
import ParameterImage from './ParameterImage';

const Pairs = ({ options, setFinalAnswers, currentAnswer, setCurrentAnswers }) => {
    const [allParameters, setAllParameters] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [allAnswers, setAllAnswers] = useState([]);
    const [imageView, setImageView] = useState(false);

    useEffect(() => {
        setAnswers(allAnswers);
    }, []);

    useEffect(() => {
        setImageView(Boolean(options[0].attachment_link));

        if (!currentAnswer) {
            setAllParameters(options.filter((option) => option.parent_answer_id === 0));
            const newAnswers = options.filter((option) => option.parent_answer_id === null);
            setAnswers(newAnswers.map((answer) => ({ ...answer, children: [] })));
            let collectedAnswers = [];
            for (let i = 0; i < newAnswers.length; i++) {
                collectedAnswers.push({
                    left_id: newAnswers[i].id,
                    right_ids: [],
                });
                // collectedAnswers[i].left = newAnswers[i].id
            }
            setAllAnswers(collectedAnswers);
        } else if (currentAnswer[0]) {
            const leftPart = currentAnswer
                .map((item) => options.filter((opt) => opt.id === item.left_id))
                .flat();
            leftPart.map(
                (item, index) =>
                    (item.children = currentAnswer[index].right_ids
                        .map((o) => options.filter((opt) => opt.id === o))
                        .flat())
            );
            // const rightPart = options.filter(opt => currentAnswer.map(item => item.right_ids.map(i => i === opt.id)))
            // leftPart.map(item => item.children = currentAnswer.answers[item.id].map(o => options.filter(opt => opt.id === o)).flat())
            console.log(leftPart);
            let collectedAnswers = [];
            for (let i = 0; i < leftPart.length; i++) {
                collectedAnswers.push({
                    left_id: leftPart[i].id,
                    right_ids: leftPart[i].children.map((child) => child.id),
                });
                // collectedAnswers[i].left = newAnswers[i].id
            }
            // console.log(rightPart)
            // const collectedAnswers = leftPart.map((i, index) => i.children = rightPart)
            setAnswers(leftPart);
            setAllAnswers(collectedAnswers);
        } else {
            let leftPart = options.filter((el) => currentAnswer[el.id]);
            //  console.log(leftPart)
            // const allChildren = currentAnswer.map(item => item)
            // console.log(allChildren)
            leftPart.map(
                (item) =>
                    (item.children = currentAnswer[item.id]
                        .map((o) => options.filter((opt) => opt.id === o))
                        .flat())
            );

            // console.log(leftWithChildren)
            setAnswers(leftPart);
            // setAllAnswers(leftPart)
        }
    }, [options, currentAnswer]);

    useEffect(() => {
        setFinalAnswers(allAnswers);
    }, [allAnswers, answers]);

    const handleDrop = (dropZone, item) => {
        //  console.log('dropZone', dropZone)
        // console.log('item', item)

        // const splitDropZonePath = dropZone.path.split("-");
        // const targetIndex = splitDropZonePath[splitDropZonePath.length - 1]
        const startParent = answers.find((child) => child.id === item.startId);
        const startParentIndex = answers.indexOf(startParent);
        // console.log(startParentIndex)
        const targetId = dropZone.dropableId;
        let draggingChild = null;
        let newUnselected = null;
        let currentIndex = null;
        if (item.startId == 'allParameters') {
            draggingChild = allParameters.find((child) => child.id === item.id);
            newUnselected = [...allParameters];
            currentIndex = allParameters.indexOf(draggingChild);
            const newAnswers = [...answers];
            newUnselected.splice(currentIndex, 1);
            newAnswers[dropZone.path].children.push(draggingChild);
            draggingChild.startId = targetId;
            setAllParameters(newUnselected);
            setAnswers(newAnswers);
            allAnswers[dropZone.path].right_ids.push(draggingChild.id);
            // return
        } else {
            // console.log(answers)
            //console.log(startParentIndex)
            draggingChild = answers[startParentIndex].children.find(
                (child) => child.id === item.id
            );
            newUnselected = allAnswers[startParentIndex].right_ids;
            // console.log(answers[startParentIndex])
            currentIndex = answers[startParentIndex].children.indexOf(draggingChild);
            // console.log(currentIndex)
            const newAnswers = [...answers];
            newUnselected.splice(currentIndex, 1);
            newAnswers[dropZone.path].children.push(draggingChild);
            newAnswers[startParentIndex].children.splice(currentIndex, 1);

            draggingChild.startId = targetId;
            setAnswers(newAnswers);
            allAnswers[startParentIndex].right_ids = newUnselected;
            allAnswers[dropZone.path].right_ids.push(draggingChild.id);

            // return
        }

        // console.log(currentIndex)

        return;
    };

    return (
        <div className='pairs__container'>
            <div className='pairs__groupContainer'>
                <div className='pairs__group' style={{ marginRight: '276px', flexWrap: 'wrap' }}>
                    {allParameters.map((answer, index) =>
                        imageView ? (
                            <ParameterImage option={answer} key={index} start={'allParameters'} />
                        ) : (
                            <Parameter text={answer} key={index} start={'allParameters'} />
                        )
                    )}
                </div>
            </div>
            <div className='pairs__answers'>
                {answers.map((answer, index) => (
                    <div className='pairs__group' key={index}>
                        {imageView ? (
                            <img
                                className='pairs__answerImage'
                                alt=''
                                src={answer.attachment_link}
                            ></img>
                        ) : (
                            <div className='pairs__option'>{answer.text}</div>
                        )}

                        <div
                            className={`pairs__answerGroup ${
                                imageView ? 'pairs__answerGroup_imageView' : ''
                            }`}
                        >
                            {answer.children.length < 1 && (
                                <div className='pairs__emptyCapture'>
                                    Перетащите варианты ответа сюда
                                </div>
                            )}
                            <DropZone
                                data={{
                                    path: index,
                                    //   childrenCount: currentTreeList.children.length,
                                    dropableId: answer.id,
                                }}
                                onDrop={handleDrop}
                                // path={currentPath}
                            />
                            {answer.children.map((option, i) =>
                                imageView ? (
                                    <ParameterImage option={option} key={i} start={answer.id} />
                                ) : (
                                    <Parameter text={option} key={i} start={answer.id} />
                                )
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Pairs;
